module.exports = __webpack_public_path__ + "img/student-id.3af788f8.png";